export default function parseError(error) {
    if (error instanceof Error) {
        return error.toString();
    }

    return error || '';
}
